<form class="register" [formGroup]="voucherForm" role="form" novalidate>
  <div class="row">
    <div>
      <div class="box_content">
        <div class="row">
          <div class="col-7">
            <input type="text" name="voucher_code" formControlName="voucherCode" value=""
              (keyup)="voucherCodeChange()">
          </div>
          <div class="col-4">
            <input id="check_voucher" class="" type="submit"
              value="{{ 'REGISTER.VOUCHER.CHECK' | translate }}">
            <br style="clear:both;">
          </div>
        </div>
        @if (voucherForm.hasError('invalidVoucher')) {
          <div class="alert alert-danger">
            {{ 'REGISTER.VOUCHER.ERROR.INVALID_VOUCHER' | translate }}
          </div>
        }
        @if (voucherForm.controls['voucherCode'].value) {
          <div class="checkbox voucher_agreement">
            @if (!voucherForm.controls['voucherAgreement'].valid && voucherForm.controls['voucherAgreement'].touched) {
              <div
                class="error">
                @if (voucherForm.controls['voucherAgreement'].errors?.required) {
                  <div class="error">
                    {{'REGISTER.VOUCHER.ERROR.MISSING_AGREEMENT' | translate }}
                  </div>
                }
              </div>
            }
            <input type="checkbox" formControlName="voucherAgreement" id="checkbox3">
            <label for="checkbox3">{{'REGISTER.VOUCHER.AGREEMENT' | translate }}</label>
          </div>
        }
        <!-- <input class="" data-step="4" type="submit" value="{{ 'REGISTER.GENERAL.NEXT_STEP' | translate }}"> -->
      </div>
    </div>
  </div>
</form>
